// extracted by mini-css-extract-plugin
export default {"StyledReceipt":"finalAdd_StyledReceipt__CWMcT"};